package pl.decks.personal.components.layouts.site

import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.serialization.Serializable
import pl.decks.posthog.client.PostHogEvent


object SiteNavigationJourney {
    @Serializable
    data object LogoBannerClicked : PostHogEvent("site_logo_banner_clicked")

    @Serializable
    data class ColorModeSelected(val mode: ColorMode) : PostHogEvent("color_mode_selected")

    @Serializable
    data class HeaderNavigated(val target: String) : PostHogEvent("header_navigated")

    @Serializable
    data object SourceCodeVisited : PostHogEvent("source_code_visited")
    @Serializable
    data class MailContactInitiated(val email: String) : PostHogEvent("mail_contact_initiated")

    @Serializable
    data class RouteChanged(val previousPath: String?, val nextPath: String?) : PostHogEvent("route_changed")
}
